import { render, staticRenderFns } from "./AlertsHistory.vue?vue&type=template&id=3fe86b74&scoped=true"
import script from "./AlertsHistory.vue?vue&type=script&lang=js"
export * from "./AlertsHistory.vue?vue&type=script&lang=js"
import style0 from "./AlertsHistory.vue?vue&type=style&index=0&id=3fe86b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe86b74",
  null
  
)

export default component.exports